import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { Text, Label } from '@leverege/ui-elements'

import CreateContactDialog from './CreateContactDialog'
import PaginationSearch from '../utils/PaginationSearch'
import { ContactActions, BreadcrumbActions, Constants, SystemActions } from '~/actions'
import { Screen, YesNoDialog, TextInput, LabelGroup } from '~/views'

import style from './style.css'

class ContactScreen extends React.Component {

  constructor( props, context ) {
    super( props, context );

    this.pager = new PaginationSearch( this, 'contacts', ( props, opts ) => {
      const { params } = props.match
      this.props.dispatch( ContactActions.list( params.systemId, opts ) )
    } )

    this.state = { 
      selectedId : null, 
      showDialog : false, 
      removeDevice : null, 
      edit : null,
      start : this.pager.getStartFrom( props ), 
      search : this.pager.getSearchFrom( props )
    }
  }

  componentDidMount() {
    const { match, dispatch } = this.props
    const { systemId } = match.params
    if ( systemId ) {
      dispatch( SystemActions.get( systemId ) )
    }
    this.pager.loadPage( this.props )
    dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Systems' } ] ) )
  }

  componentWillReceiveProps( next ) {
    const nid = next.match.params && next.match.params.systemId
    const sys = nid && next.systems && next.systems.lookup[nid]
    if ( sys ) {
      this.props.dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${sys.projectId}/system` }, { name : `${sys.name} / Contacts` } ] ) )
    }

    this.pager.loadIfNeeded( next )
  }

  onCreate = ( contact ) => {
    const { dispatch } = this.props
    const { id, ...attr } = contact
    dispatch( id == null ? 
      ContactActions.create( this.props.match.params.systemId, attr ) : 
      ContactActions.update( this.props.match.params.systemId, id, attr ) )
    this.setState( { showDialog : false } )
  }

  onEdit( contact ) {
    this.setState( { showDialog : true, edit : contact } )
  }

  onPromptRemoveYes = () => {
    const { dispatch } = this.props
    const { removeContact } = this.state
    dispatch( ContactActions.delete( removeContact.systemId, removeContact.id ) );
    this.setState( { showRemoveDialog : false, removeContact : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeContact : null } )
  }

  options( row ) {
    return (
      <div>
        <DropdownButton pullRight
          bsStyle="link" 
          title={<i className="fa fa-gear fa-fw" />}
          id={`options-${row.original.id}`}>
          <MenuItem bsStyle="link"
            bsSize="large"
            className={style.deviceButton} 
            onClick={() => { this.onEdit( row.original ) }}> 
            <i className="fa fa-pencil fa-fw" />
            {' '}
            Edit 
          </MenuItem>
          <MenuItem divider />
          <MenuItem bsStyle="link"
            bsSize="large"
            className={style.deviceButton} 
            onClick={() => { this.setState( { showRemoveDialog : true, removeContact : row.original } ) }}> 
            <i className="fa fa-times fa-fw" />
            {' '}
            Delete 
          </MenuItem>
        </DropdownButton>
      </div>
    )
  }

  render() {
    const systemId = this.props.match.params.systemId
    const { contacts } = this.props
    const { removeContact, showRemoveDialog, selectedId, start, search } = this.state
    const isSelected = function( item ) { return item && item.id == selectedId; }

    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const perPage = this.pager.getPerPage()

    const items = contacts.systemId == systemId ? this.pager.getPageItems() : []
    // items = items.slice( )
    const columns = [ 
      { Header : 'Name', accessor : 'name' },
      { Header : 'Email', accessor : 'email' },
      { Header : 'Phone', accessor : 'phone' },
      { Header : '',
        id : 'options',
        width : 60,
        Cell : ( row ) => {
          return this.options( row )
        } }
    ]
    const table = (
      <ReactTable
        className={classnames( '-striped -highlight', style.table, items.length == 0 && 'empty' )}
        manual
        data={items}
        columns={columns}
        loading={contacts.status == Constants.STATUS_LOADING}
        showPageSizeOptions={false}
        NOdefaultPageSize={Math.max( contacts.perPage, items.length )}
        pageSize={Math.min( contacts.perPage, items.length )}
        pages={contacts.total == 0 ? 0 : Math.ceil( contacts.total / contacts.perPage )}
        showPagination
        showPaginationBottom
        noDataText="No contacts found"
        onFetchData={( state, instance ) => { this.pager.onPageChange( state.page + 1 ) }}
        getTdProps={( state, rowInfo, column, instance ) => {
          return {
            onDoubleClick : ( e ) => { this.onEdit( rowInfo.original ) },
            style : {
              // background : this.isSelected( rowInfo.original ) ? 'rgba(255,200,0,0.35)' : null 
            }
          }
        }} />
    )
    
    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <span>
            <Text variant="screenTitle" style={{ display : 'inline', marginRight : '8px' }}>Contacts</Text> 
            {total ? (
              <span className={style.count}>
                (
                {' '}
                {start}
                {' '}
                -
                {' '}
                {Math.min( total, start + perPage )}
                {' '}
                out of
                {' '}
                {total}
                {' '}
                )
              </span>
            ) : null }
          </span>
          <div style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <Label><i className="fa fa-search" /></Label>
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={() => { this.setState( { edit : null, showDialog : true } ) }}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              New Contact
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          {table}
        </Screen.Content>

        { this.state.showDialog && 
          (
            <CreateContactDialog
              edit={this.state.edit}
              show 
              onHide={() => { this.setState( { showDialog : false } ) }} 
              onCreate={this.onCreate} />
          )}
        <YesNoDialog show={showRemoveDialog} 
          title={`Remove ${removeContact && removeContact.name}?`}
          message={<div>Are you sure you want to delete the Contact?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />
        
      </Screen>
    );
  }
} 

export default connect(
  state => ( {
    systems : state.systems,
    contacts : state.contacts
  } )
)( ContactScreen );
